const privilegesSelector = (state) => state.privilege.privileges

export { privilegesSelector }
